// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 4%;
}

.summary-header {
  height: 12%;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.summary-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #111827;
  margin: 0;
}

.summary-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.dropdown-container {
  position: relative;
}

.change-summary-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #0d9488;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.change-summary-button:hover {
  background-color: #f9fafb;
}

.summary-action-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.summary-action-button:hover {
  background: #f9fafb;
}

.summary-action-button.save-button {
  background: #0d9488;
  color: white;
  border: none;
}

.action-button.save-button:hover {
  background: #0f766e;
}

.summary-content {
  width: 100%;
  max-width: 120%;
  height: 85%;
  padding: 24px;
  overflow-y: auto;
}

.summary-editor {
  width: 100%;
  height: 100%;
  min-height: 300px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.6;
  font-family: inherit;
  resize: none;
  color: #374151;
}

.summary-editor:focus {
  outline: none;
  border-color: #0d9488;
  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.1);
}

.markdown-content {
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
}

.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.markdown-content h4,
.markdown-content h5,
.markdown-content h6 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  font-weight: 500;
  color: #111827;
}

.markdown-content p {
  margin: 1em 0;
}

.markdown-content ul,
.markdown-content ol {
  margin: 1em 0;
  padding-left: 1.5em;
}

.markdown-content li {
  margin: 0.5em 0;
}

@media (max-width: 580px) {
  .summary-container {
    overflow: auto;
  }
  .summary-header {
    height: 12%;
    padding: 10px;
    padding-left: 4px;
    padding-right: 4px;
    justify-content: space-evenly;
  }
  .summary-title {
    font-weight: 500;
    font-size: 14px;
  }
  .change-summary-button {
    gap: 2px;
    padding: 8px;
    font-size: 14px;
  }
  .action-button {
    gap: 2px;
    padding: 8px;
    font-size: 12px;
  }

  .summary-content {
    padding: 14px;
  }

  .markdown-content {
    font-size: 14px;
    line-height: 1.4;
  }
  .markdown-content h1,
  .markdown-content h2,
  .markdown-content h3,
  .markdown-content h4,
  .markdown-content h5,
  .markdown-content h6 {
    margin-top: 1em;
  }
  .markdown-content ul,
  .markdown-content ol {
    padding-left: 1.3em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/selectedSessionComponent/SummaryView.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,QAAQ;IACR,YAAY;IACZ,eAAe;EACjB;EACA;IACE,QAAQ;IACR,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;;;;;;IAME,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":[".summary-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  box-sizing: border-box;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 4%;\n}\n\n.summary-header {\n  height: 12%;\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.summary-title {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #111827;\n  margin: 0;\n}\n\n.summary-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.dropdown-container {\n  position: relative;\n}\n\n.change-summary-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  color: #0d9488;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.change-summary-button:hover {\n  background-color: #f9fafb;\n}\n\n.summary-action-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  color: #374151;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.summary-action-button:hover {\n  background: #f9fafb;\n}\n\n.summary-action-button.save-button {\n  background: #0d9488;\n  color: white;\n  border: none;\n}\n\n.action-button.save-button:hover {\n  background: #0f766e;\n}\n\n.summary-content {\n  width: 100%;\n  max-width: 120%;\n  height: 85%;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n.summary-editor {\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 14px;\n  line-height: 1.6;\n  font-family: inherit;\n  resize: none;\n  color: #374151;\n}\n\n.summary-editor:focus {\n  outline: none;\n  border-color: #0d9488;\n  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.1);\n}\n\n.markdown-content {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #374151;\n}\n\n.markdown-content h1,\n.markdown-content h2,\n.markdown-content h3,\n.markdown-content h4,\n.markdown-content h5,\n.markdown-content h6 {\n  margin-top: 1.5em;\n  margin-bottom: 0.5em;\n  font-weight: 500;\n  color: #111827;\n}\n\n.markdown-content p {\n  margin: 1em 0;\n}\n\n.markdown-content ul,\n.markdown-content ol {\n  margin: 1em 0;\n  padding-left: 1.5em;\n}\n\n.markdown-content li {\n  margin: 0.5em 0;\n}\n\n@media (max-width: 580px) {\n  .summary-container {\n    overflow: auto;\n  }\n  .summary-header {\n    height: 12%;\n    padding: 10px;\n    padding-left: 4px;\n    padding-right: 4px;\n    justify-content: space-evenly;\n  }\n  .summary-title {\n    font-weight: 500;\n    font-size: 14px;\n  }\n  .change-summary-button {\n    gap: 2px;\n    padding: 8px;\n    font-size: 14px;\n  }\n  .action-button {\n    gap: 2px;\n    padding: 8px;\n    font-size: 12px;\n  }\n\n  .summary-content {\n    padding: 14px;\n  }\n\n  .markdown-content {\n    font-size: 14px;\n    line-height: 1.4;\n  }\n  .markdown-content h1,\n  .markdown-content h2,\n  .markdown-content h3,\n  .markdown-content h4,\n  .markdown-content h5,\n  .markdown-content h6 {\n    margin-top: 1em;\n  }\n  .markdown-content ul,\n  .markdown-content ol {\n    padding-left: 1.3em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
